// SOVRANOVA — curated companion voices (ElevenLabs).
// These set the SPOKEN GUIDANCE voice: greetings, guidance, affirmations,
// hypnosis and crisis lines — everything SOVRANOVA narrates via ElevenLabs.
// The live Hume conversation uses Hume's own voice, configured separately.
export const VOICES = [
  { id: 'EXAVITQu4vr4xnSDxMaL', name: 'Sarah',   gender: 'Female', tone: 'Mature, reassuring, confident' },
  { id: 'pFZP5JQG7iQjIQuC4Bku', name: 'Lily',    gender: 'Female', tone: 'Velvety, soothing (British)' },
  { id: 'hpp4J3VqNfWAUOO0d1Us', name: 'Bella',   gender: 'Female', tone: 'Warm, bright, professional' },
  { id: 'XrExE9yKIg1WjnnlVkGX', name: 'Matilda', gender: 'Female', tone: 'Warm, knowledgeable' },
  { id: 'nPczCjzI2devNBz1zQrb', name: 'Brian',   gender: 'Male',   tone: 'Deep, resonant, comforting' },
  { id: 'JBFqnCBsd6RMkjVDRZzb', name: 'George',  gender: 'Male',   tone: 'Warm storyteller (British)' },
]

// Default spoken-guidance voice = Sarah.
export const DEFAULT_VOICE_ID = 'EXAVITQu4vr4xnSDxMaL'

// The user's chosen SPOKEN-GUIDANCE voice (ElevenLabs). Read straight from the
// settings store so plain modules (services/speech.js, hooks/useSession.js) can
// use it without a React context. Falls back to the app default (Sarah).
// WHY: until 14 Aug the session's inline reply audio used the SERVER default
// voice while other surfaces honoured the picker — in the first live couples
// session the companion audibly changed voice between messages. Every ElevenLabs
// call now carries this same id.
export function getGuidanceVoiceId() {
  try { return JSON.parse(localStorage.getItem('sovranova_settings_v1') || '{}').voiceId || DEFAULT_VOICE_ID }
  catch { return DEFAULT_VOICE_ID }
}

// The user's chosen LIVE conversation voice (Hume EVI). Empty string = no override
// (use the app's default EVI config voice). Read from the same settings store the
// pickers write; passed to connect({ voiceId }) on every Hume voice surface.
export function getHumeVoiceId() {
  try { return JSON.parse(localStorage.getItem('sovranova_settings_v1') || '{}').humeVoiceId || '' }
  catch { return '' }
}
